import React, { lazy, Suspense } from 'react';
import { Route, Redirect, HashRouter } from 'react-router-dom';
import { ContextLayout } from './Utility/context/layout';
import { History } from './history';
// import Loading from './Components/loading/Loading.componnet';
import { Company, ContextCompany } from './Utility/context/company';
import CustomSwitch from './Utility/CustomSwitch';
import Cookies from 'js-cookie';
import AxiosInstance from './Utility/axios';
// import InvoiceView from './Pages/home/invoiceView.page';
// import { toast } from 'react-toastify';
// import TwitterShare from './Components/modal/TwitterShare.modal';
const InvoiceView = lazy(() => import('./Pages/home/invoiceView.page'));
const LoginPage = lazy(() => import('./Pages/login/login.page'));
const SignupPage = lazy(() => import('./Pages/signup/signup.page'));
const ForgetPasswordPage = lazy(() =>
  import('./Pages/forgetPassword/forgetPassword.page')
);
const RecoveryPasswordPage = lazy(() =>
  import('./Pages/forgetPassword/recoverPassword.page')
);
const NewPasswordPage = lazy(() =>
  import('./Pages/forgetPassword/newPassword.page')
);
const HomePage = lazy(() => import('./Pages/home/home.page'));
const ClientPage = lazy(() => import('./Pages/client/clent.page'));
const MemberPage = lazy(() => import('./Pages/member/member.page'));
const ReportPage = lazy(() => import('./Pages/report/report.page'));

const InvoiceSetting = lazy(() =>
  import('./Pages/setting/InvoiceSetting.page')
);
const EmailTemplatePage = lazy(() =>
  import('./Pages/setting/emailTemplate.page')
);
const PaymentMethodPage = lazy(() =>
  import('./Pages/setting/paymentMethod.page')
);
const AccountPage = lazy(() => import('./Pages/setting/account.page'));
const CompnaySettingsPage = lazy(() =>
  import('./Pages/setting/companySettings.page')
);
const EmailVerifyPage = lazy(() => import('./Pages/signup/emailverify.page'));
const StripeRedirectPage = lazy(() =>
  import('./Pages/stripeRedirect/stripeRedirect.page')
);
const NotFound404 = lazy(() => import('./Pages/errorPage/notFound404.page'));
const Authorize401 = lazy(() => import('./Pages/errorPage/403.page'));
// const serverError500 = lazy(() => import('./Pages/errorPage/500.page'));
const LoadingPage = lazy(() =>
  import('./Components/loading/Loading.componnet')
);
const PaypalRedirectPage = lazy(() =>
  import('./Pages/paypalRedirect/PaypalRedirect.page')
);

const DisabledRoutesForMembers = [
  '/:company_id/members',
  '/:company_id/invoice-settings',
  '/:company_id/payment-methods',
  '/:company_id/company-settings',
];

const AppRoute = ({
  component: Component,
  DashboardLayout,
  SettingsLayout,
  ...rest
}) => {
  if (sessionStorage.getItem('data') !== null) {
    var access_token = JSON.parse(sessionStorage.getItem('data')).access_token;
    var role = JSON.parse(sessionStorage.getItem('data')).role;
  }

  if (!access_token) {
    return <Redirect to='/login' />;
  }

  if (
    role === 'member' &&
    DisabledRoutesForMembers.some((path) => path === rest.path)
  ) {
    return <Redirect to='/unauthorize' />;
  }

  return (
    <Route
      {...rest}
      render={(props) => (
        <ContextLayout.Consumer>
          {(context) => {
            let LayoutTag =
              DashboardLayout === true
                ? context.DashboardLayout
                : context.SettingsLayout;
            return (
              <Company {...props}>
                <ContextCompany.Consumer>
                  {(company) => {
                    return (
                      <LayoutTag {...props} {...company}>
                        <Component {...props} {...company} />
                      </LayoutTag>
                    );
                  }}
                </ContextCompany.Consumer>
              </Company>
            );
          }}
        </ContextLayout.Consumer>
      )}
    />
  );
};

const PublicRoute = ({ componnet: component, ...rest }) => {
  if (sessionStorage.getItem('data') !== null) {
    var access_token = JSON.parse(sessionStorage.getItem('data')).access_token;

    var company = JSON.parse(sessionStorage.getItem('data')).company;

    var redirect_url = `/${company[0].id}/invoices`;

    var subscription = JSON.parse(sessionStorage.getItem('data')).subscription;
    if (subscription !== null && !subscription.is_trial) {
      if (!subscription.is_subscribed) {
        redirect_url = `/${company[0].id}/your-account`;
      }
    }

    if (
      JSON.parse(sessionStorage.getItem('data')).company.length > 0 &&
      subscription !== null &&
      (subscription.is_trial || subscription.is_subscribed)
    ) {
      redirect_url = `/${
        JSON.parse(sessionStorage.getItem('data')).company[0].id
      }/invoices`;
    }
  }

  if (rest.location.search.length > 5) {
    redirect_url += rest.location.search;
  }

  if (access_token) {
    return <Redirect to={redirect_url} />;
  }
  return <Route component={component} {...rest} />;
};

const AppRouter = () => {
  if (Cookies.get('user')) {
    sessionStorage.setItem('data', Cookies.get('user'));
    AxiosInstance.defaults.headers.common['Authorization'] = `Bearer ${
      JSON.parse(Cookies.get('user')).access_token
    }`;
  }

  return (
    <HashRouter basename='/' history={History}>
      <Suspense fallback={<LoadingPage />}>
        <CustomSwitch>
          <AppRoute
            exact
            path='/:company_id/invoices'
            component={HomePage}
            DashboardLayout
          />
          <AppRoute
            exact
            path='/:company_id/clients'
            component={ClientPage}
            DashboardLayout
          />

          <AppRoute
            exact
            path='/:company_id/members'
            component={MemberPage}
            DashboardLayout
          />
          <AppRoute
            exact
            path='/:company_id/reports'
            component={ReportPage}
            DashboardLayout
          />
          <AppRoute
            exact
            path='/:company_id/invoice-settings'
            component={InvoiceSetting}
            SettingsLayout
          />
          <AppRoute
            exact
            path='/:company_id/email-template'
            component={EmailTemplatePage}
            SettingsLayout
          />
          <AppRoute
            exact
            path='/:company_id/payment-methods'
            component={PaymentMethodPage}
            SettingsLayout
          />
          <AppRoute
            exact
            path='/:company_id/your-account'
            component={AccountPage}
            SettingsLayout
          />
          <AppRoute
            exact
            path='/:company_id/company-settings'
            component={CompnaySettingsPage}
            SettingsLayout
          />
          {/* Public Routes */}
          <PublicRoute exact path='/login' component={LoginPage} />
          <PublicRoute exact path='/' component={LoginPage} />
          <PublicRoute exact path='/signup' component={SignupPage} />
          <PublicRoute
            exact
            path='/forgot-password'
            component={ForgetPasswordPage}
          />
          <PublicRoute
            exact
            path='/recover-password'
            component={RecoveryPasswordPage}
          />
          <PublicRoute
            exact
            path='/reset-password'
            component={NewPasswordPage}
          />
          <Route
            exact
            path='/:company_id/invoice/:invoice_uuid/view'
            component={InvoiceView}
          />
          <Route exact path='/email-verify' component={EmailVerifyPage} />
          <Route path='/stripe-account' component={StripeRedirectPage} />
          <Route path='/connect-paypal' component={PaypalRedirectPage} />
          <Route exact path='/unauthorize' component={Authorize401} />
          <Route path='*' component={NotFound404} />
        </CustomSwitch>
      </Suspense>
    </HashRouter>
  );
};

export default AppRouter;
